const DOMAIN = 'clLowlands.services.websockets.';

const CONNECTION_ALREADY_OPENED = `${DOMAIN}connectionAlreadyOpened`;
const CONNECTION_ALREADY_CLOSED = `${DOMAIN}connectionAlreadyClosed`;
const CONNECTION_NOT_OPENED = `${DOMAIN}connectionNotOpened`;

export {
  CONNECTION_ALREADY_OPENED,
  CONNECTION_ALREADY_CLOSED,
  CONNECTION_NOT_OPENED,
};
